import React from 'react';
import TeamLearning from '@assets/LandingPage/TeamLearning.png';
import './GetStartedHero.css';

export default function GetStartedHero() {
  return (
    <div className="get-started-container">
      {/* Grid overlay */}
      <div className="get-started-grid-overlay">
        <div className="get-started-grid-pattern"></div>
      </div>

      <div className="get-started-content">
        {/* ───── LEFT ───── */}
        <div className="get-started-left-section">
          <h1 className="get-started-heading">
            Ready to Transform Your Team's Learning?
          </h1>

          <p className="get-started-description">
            Join thousands of companies already using Mile LXP to drive results.
          </p>

          <button className="get-started-button">
            Get Started
          </button>
        </div>

        {/* ───── RIGHT ───── */}
        <div className="get-started-right-section">
          {/* Tilted background square (behind the card) */}
          <div className="get-started-tilted-square"></div>

          {/* White card with image */}
          <div className="get-started-image-card">
            <div className="get-started-image-placeholder">
              <img
                src={TeamLearning}
                alt="Team Learning"
                className="get-started-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
